import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import { useLogger } from '@booksy-com/vue-tools'

import { useCore } from '@/composables/core'
import { ENDPOINTS } from '@/lib/consts'

const logger = useLogger('polls-composable')

export type UsePollsReturn = {
  loadPollsList: (pollsGroupName?: string) => Promise<unknown>
  savePoll: (payload: { pollName?: string; choices?: unknown[] }) => Promise<void>
}

export function usePolls (): UsePollsReturn {
  const { apiCall, store } = useCore()
  const business: ComputedRef<{ id: string } | undefined> = computed(() => (store.state as { business?: { business?: { id: string } } })?.business?.business)

  const loadPollsList = async (pollsGroupName?: string): Promise<unknown> => {
    if (!business.value) {
      logger.error('loadPollsList called without business id')
      return undefined
    }
    try {
      const response = await apiCall({
        method: 'POST',
        url: ENDPOINTS.POLLS_LIST,
        urlParams: {
          businessId: business.value.id,
        },
        data: {
          group_name: pollsGroupName,
        },
      })

      return (response as { data: unknown }).data
    } catch (error) {
      logger.error(error)
      return null
    }
  }

  const savePoll = async ({ pollName, choices }: { pollName?: string; choices?: unknown[] }): Promise<void> => {
    if (!business.value) {
      logger.error('savePoll called without business id')
      return
    }

    try {
      await apiCall({
        method: 'POST',
        url: ENDPOINTS.POLL,
        urlParams: {
          businessId: business.value.id,
        },
        data: {
          poll_name: pollName,
          choice_ids: choices,
        },
      })
      return Promise.resolve()
    } catch (error) {
      logger.error(error)
      return Promise.reject(error)
    }
  }

  return {
    loadPollsList,
    savePoll,
  }
}
